<template>
  <div class="custom-swiper">
    <div class="item-hd">
      <div class="item-title">皇家行前订手机端使用指南</div>
      <div class="item-tips">
        <p style="text-indent: 2em;">已预订船票客人需备有船票订单号或舱房号进行预订，皇家官网、微信小程序或飞猪旗舰店客人可通过船票预订成功短信或邮件查看订单信息，旅行社客人请联系相关销售人员咨询舱房信息。</p>
      </div>
    </div>
    <swiper :options="swiperOption">
      <swiper-slide v-for="(item,index) in listData" :key="index">
        <div class="swiper-item">
          <div class="item-bd">
            <div class="item-bd-left" @click="playVideo(index+1)">
              <!-- <img src="../../assets/beginners_tips_img01.gif" alt=""> -->
              <img src="https://resource.rcclchina.com.cn/PCP/PROD/Mobile/WechatIMG1869.png" alt="">
            </div>
            <div class="item-bd-right">
              <div class="right-number">
                STEP <span>{{(index+1)>9 ? (index+1) : '0'+(index+1) }}</span>
              </div>
              <div class="right-content">
                <div class="content-top">
                  {{item.title}}
                </div>
                <div class="content-bottom">
                  {{item.text}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div :class="show?'pop-box cur':'pop-box'">
      <van-icon name="cross" class="pop-close-btn" @click="closePop"/>
      <video class="pop-video"
        webview.allowsInlineMediaPlayback = 'yes'
        webkit-playsinline
        playsinline
        autoplay
        controls
        x5-video-player-type="h5"
        x5-video-orientation="portraint"
        ref="video"
        :src="videoUrl">
      </video>
      <!-- <video id="playVideos" ref="video" autoplay="autoplay" loop="loop" muted width="100%" height="100%">
        <source :src="videoUrl" type="video/mp4">
      </video> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'BeginnersTipsSwiper',

  data () {
    return {
      show: false,
      videoUrl: 'https://resource.rcclchina.com.cn/PCP/PROD/videos/Step1.mp4',
      swiperOption: {
        autoplay: false,
        pagination: {
          el: '.swiper-pagination'
        }
      },
      listData: [
        {
          title: '使用手机号登陆会员，输入船票订单号或舱房号绑定船票',
          text: ''
        },
        {
          title: '浏览您感兴趣的产品详情，选择加入购物车',
          text: '*部分活动对于参与人身高年龄等有限制，请务必查看产品详情'
        },
        {
          title: '选择产品日期时段和参与人，进入订单确认页',
          text: ''
        },
        {
          title: '选择预订支付人作为整张订单的付款人，阅读条款细则后提交订单',
          text: '*订单费用将于登轮后于预订支付人绑定船卡中扣除'
        },
        {
          title: '完成预订，可选择查看订单详情或为其他房间客人创建订单',
          text: '*您将会收到确认短信和邮件便于后续查找订单'
        }
      ],
      playing: false
    }
  },
  methods: {
    playVideo (index) {
      this.$refs.video.displayTime = '00:00'
      this.videoUrl = `https://resource.rcclchina.com.cn/PCP/PROD/videos/Step${index}.mp4`
      // this.$refs.video.src(`https://resource.rcclchina.com.cn/PCP/PROD/videos/Step${index}.mp4`)
      this.$refs.video.play()
      this.show = true
      try {
        this.$refs.video.addEventListener('ended', e => {
          this.$refs.video.pause()
          this.show = false
          console.log(e)
          
        })
      } catch (e) {
        // 捕获url异常出现的错误
      }
    },
    closePop () {
      this.$refs.video.pause()
      // this.videoUrl = ''
      this.show = false
    }
  }
}
</script>

<style lang="less" scoped>
.custom-swiper{
  padding: 70px 50px 50px;
  .pop-box {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    background-color: #ffffff;
    transition: all .3s ease;
    opacity: 0;
    transform: scale(.5);
    visibility: hidden;
    &.cur{
      opacity: 1;
      transform: scale(1);
      visibility: visible;
    }
    .pop-close-btn{
      position: absolute;
      right: 3%;
      top: 2%;
      font-size: 70px;
      background-color: rgba(0,0,0,.5);
      color: #ffffff;
      z-index: 110;
    }
  }
  .pop-video {
    width: 100%;
    height: 100%;
  }
  .item-hd{
    font-size: 24px;
    line-height: 1.8;
    color: @main-gray3;
    text-align: center;
    .item-title{
      font-size: 30px;
      font-weight: bold;
      color: @main-color;
      padding-bottom: 24px;
    }
  }
  .swiper-pagination{
    bottom: 20px;
  }
  .swiper-item{
    height: 600px;
    .item-bd{
      display: flex;
      padding-top: 50px;
      .item-bd-left{
        width: 243px;
        // height: 496px;
        margin-right: 40px;
        margin-left: 4px;
        img{
          width: 100%;
        }
      }
      .item-bd-right{
        flex: 1;
        font-size: 24px;
        color: @main-gray4;
        line-height: 1.8;
        .right-number{
          padding-bottom: 20px;
          span{
            font-size: 60px;
            color: #242e65;
            font-weight: bold;
          }
        }
        .content-top{
          color: @main-gray3;
        }
      }
    }
  }
  .item-tips {
    text-align: left;
  }
}

</style>
